// extracted by mini-css-extract-plugin
export default {"account-header":"AccountAdminAccount_account-header__+pRH0","account-header-name":"AccountAdminAccount_account-header-name__NLY2f","content":"AccountAdminAccount_content__KaROE"};